import { ONBOARDING, variantsThatShowProgressiveDisclosure } from '../../pages/setup/constants';
import { useSellerOnboardingVariant, useSellerOnboardingJson } from '../../hooks/use-seller-setting';
import { useEnableSetupFlow } from './use-enable-setup-flow';

export const useShowProgressiveDisclosure = () => {
  const isSetupEnabled = useEnableSetupFlow();
  const { currentPage } = useSellerOnboardingJson();
  const isSetupComplete = currentPage === ONBOARDING;
  const sellerOnboardingVariant = useSellerOnboardingVariant();
  const hasVariantThatShowsProgressiveDisclosure = variantsThatShowProgressiveDisclosure.includes(sellerOnboardingVariant);
  if (!isSetupEnabled) {
    return false;
  }
  return !isSetupComplete && hasVariantThatShowsProgressiveDisclosure;
};
